import React from 'react';
import { STEPS } from '../mock';

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-[#f5f5f3] py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[11px] font-semibold tracking-[0.18em] text-[#FF6A1A]">HOW IT WORKS</span>
          <h2 className="mt-3 text-[34px] md:text-[46px] font-semibold tracking-[-0.02em] text-[#0f0f10]">
            Get moving in 3 taps
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5 md:gap-6">
          {STEPS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                className="group relative bg-white rounded-3xl p-7 md:p-8 border border-black/[0.06] hover:border-[#FF6A1A]/40 hover:-translate-y-1 transition-[transform,border-color,box-shadow] duration-300 hover:shadow-[0_30px_60px_-30px_rgba(15,15,16,0.25)]"
              >
                <div className="flex items-start justify-between">
                  <div className="w-11 h-11 rounded-xl bg-[#FFF1E6] text-[#FF6A1A] grid place-items-center">
                    <Icon size={20} />
                  </div>
                  <div className="text-[13px] font-semibold tracking-[0.18em] text-[#FF6A1A]">{s.n}</div>
                </div>
                <h3 className="mt-6 text-[22px] md:text-[24px] font-semibold text-[#0f0f10] tracking-[-0.01em]">{s.title}</h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-[#6b6b70]">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
